<template>
    <div class="AdminUsersDetail">
        <WCard>
            <EntityItemDetail
                :value="user"
                :columns="columns"
            />
        </WCard>
    </div>
</template>
<script>
import {
    Api, apiRequest, rethrowError, notifyError,
} from '@/api'
import { entityMixin } from '@/mixins'
import { EntityItemDetail } from '@/components'
import { COLUMNS } from './grid'

export default {
    name: 'AdminUsersDetail',
    components: {
        EntityItemDetail,
    },
    mixins: [entityMixin],
    metaInfo () {
        return {
            title: this.$t(`admin.navigation.users`),
        }
    },
    entity () {
        const { id } = this.$route.params

        return {
            breadcrumbs: [
                {
                    key: 'AdminImportsList',
                    label: id,
                    to: { name: 'AdminUsersDetail', params: { id } },
                },
            ],
            buttons: [{
                iconLeft: 'edit',
                text: this.$t('entities.actions.edit'),
                onClick: () => this.$router.push({ name: 'AdminUsersEdit', params: { id } }),
            }],
        }
    },
    data () {
        return {
            user: undefined,
            columns: COLUMNS,
            isFetching: false,
        }
    },
    beforeMount () {
        const { id } = this.$route.params
        this.id = id
    },
    mounted () {
        this.getUser()
    },
    methods: {
        async getUser () {
            this.isFetching = true
            apiRequest(Api().admin.usersDetail({ id: this.id }))
                .then(data => (this.user = data))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isFetching = false))
        },
    },
}
</script>
<style lang="scss" scoped>
.WCard {
	@include admin-screen-height(54px);
}
</style>
